import React, { useState, useEffect } from "react";
import NavHeader from "../components/navigation/NavHeader";
import Footer from "../components/navigation/Footer";
import GoUpDown from "../components/navigation/GoUpDown";
import CommunityAccordion from "../components/community/CommunityAccordion";
import CommunityAccordionSkeleton from "../components/skeletons/CommunityAccordionSkeleton";
import AsideLeft from "../components/aside/AsideLeft";
import AsideRight from "../components/aside/AsideRight";
import JobListingCommunityAccordion from "../components/joblisting/JobListingCommunityAccordion";
import CommunityLayout from "../components/layouts/CommunityLayout";
import CommunityRequestIcon from "../components/icons/Community";
import { usePageTitle } from '../hooks/usePageTitle';

const Home = () => {

    usePageTitle('Home - Wefayo');
    const [isLoading, setIsLoading] = useState(true);
    const [displayedCommunities, setDisplayedCommunities] = useState([]);
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [ currentCommunity, setCurrentCommunity ] = useState(null);


    // const [jobListing, setJobListing] = useState(null);


    const onPinCommunityChanged = async () => {
        // fetchCommunities();
    }



    const getCommunityStatistics = (community) => {
        let posts = "";
        let replies = "";
        if (community?.forums?.length > 0) {
            posts = community.forums.reduce((acc, forum) => acc + parseInt(forum.count_of_posts ?? 0), 0);
            replies = community.forums.reduce((acc, forum) => acc + parseInt(forum.count_of_replies ?? 0), 0);
        }
        return `${posts} posts, ${replies} replies`;
    }

    const onCommunitiesLoaded = (communities, loggedInUser,) => {
        if (Array.isArray(communities) && communities.length > 0) {
            setDisplayedCommunities(communities);
            setLoggedInUser(loggedInUser);
        }
        setIsLoading(false);
    }

    return (
        <CommunityLayout currentPage={"communities"} onCommunitiesLoaded={onCommunitiesLoaded}  currentCommunity={currentCommunity} setCurrentCommunity={setCurrentCommunity}>

            <div className="flex-grow flex flex-col  ">
                <div className="flex flex-col gap-y-2 ">

                    {/* 
                    cbh:40
                    {isLoading &&
                        <>
                            <CommunityAccordionSkeleton></CommunityAccordionSkeleton>
                            <CommunityAccordionSkeleton items={2}></CommunityAccordionSkeleton>
                            <CommunityAccordionSkeleton items={3}></CommunityAccordionSkeleton>
                        </>
                    } */}


                    <div className="flex flex-col gap-y-2 ">
                        {currentCommunity &&
                            <CommunityAccordion
                                onPinCommunityChanged={onPinCommunityChanged}
                                currentCommunity={currentCommunity}
                            />
                        }
                    </div>

                </div>
            </div>

        </CommunityLayout>
    );
};

export default Home;

